import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoadingService} from '../../services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';
import {HhgOnlineBookShipmentService} from '../hhg-online-book-shipment/hhg-online-book-shipment.service';
import {BehaviorSubject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {HhgBillOfLadingService} from 'src/app/services/hhg-bill-of-lading/hhg-bill-of-lading.service';
import {BillOfLadingService} from '../../services/bill-of-lading/bill-of-lading.service';
import {
  HhgBillOfLadingDetails
} from 'src/app/shared/common-components/common-structure';
import AppConstants from 'src/app/shared/common-components/AppConstants';
import {saveAs} from 'file-saver';

@Component({
    selector: 'app-view-document-package',
    templateUrl: './view-document-package.component.html',
    styleUrls: ['./view-document-package.component.css'],
    standalone: false
})
export class ViewDocumentPackageComponent implements OnInit {
  private observer$ = new BehaviorSubject(true);
  bookShipmentId: number;
  private tmssloader;
  show: boolean;
  message: string;
  shipmentId: number;
  selectedShipmentType: string;
  shipmentTypeArray: any[];
  isHHGSelected: boolean;
  isPOVSelected: boolean;
  isUABSelected: boolean;
  viewPdfDocForm: FormGroup;
  billOfLadingNbr: string;
  fromGenerateOrView: string;
  viewBillOfLadingPDF: boolean;
  employeeLastName: string;
  bolDetailsId: number;
  shipmentStatus: string;

  isCorrectionNotice = false;

  constructor(
    private alertService: AlertService,
    private loader: LoadingService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private bookShipmentService: HhgOnlineBookShipmentService,
    private hhgBillOfLadingService: HhgBillOfLadingService,
    private billOfLadingService: BillOfLadingService
  ) {
    this.tmssloader = this.loader;
    this.viewPdfDocForm = this.formBuilder.group({
      bookShipmentsId: new FormControl({value: '', disabled: true}),
      billOfLadingNbr: new FormControl({value: '', disabled: true})
    });
  }

  ngOnInit() {
    // this.tmssloader.show();
    this.bookShipmentId = this.route.snapshot.queryParams['bookshipmentid'];
    this.shipmentId = this.route.snapshot.queryParams['shipmentId'];
    this.selectedShipmentType = this.route.snapshot.queryParams['selectedShipmentType'];
    this.employeeLastName = this.route.snapshot.queryParams['employeeLastName'];
    this.shipmentStatus = this.route.snapshot.queryParams['status'];
    this.getGeneratedBolNumber(this.shipmentId, this.selectedShipmentType);
    console.log('this.selectedShipmentType ' + this.selectedShipmentType);
    if (null !== this.selectedShipmentType && this.selectedShipmentType !== 'FRT') {
      // this.selectedShipmentType = 'HHG';
      this.shipmentTypeArray = this.selectedShipmentType.split(' & ');
      for (let i = 0; i < this.shipmentTypeArray.length; i++) {
        if (this.shipmentTypeArray[i] === 'HHG') {
          this.isHHGSelected = true;
        }
        if (this.shipmentTypeArray[i] === 'HHG-UAB') {
          this.isUABSelected = true;
        }
        if (this.shipmentTypeArray[i] === 'HHG-POV') {
          this.isPOVSelected = true;
        }
      }
    } else {
      this.selectedShipmentType = 'FRT';
    }
    window.scrollTo(0, 0);
  }

  getGeneratedBolNumber(shipmentId, selectedShipmentType) {
    this.loader.show();
    this.billOfLadingService.getBolNumberByShipmentId(shipmentId, selectedShipmentType).subscribe(data => {
      if (AppConstants.isNotNullCondition(data)) {
        this.billOfLadingNbr = data.billOfLadingNbr;
        this.bolDetailsId = data.bolDetailsId;
      }
      // this.loader.hide();
    }, error => {
      this.loader.hide();
      console.log('There was an error getting the bol number =>' + error);
      this.alertService.error('Error getting the bol number');
    }, () => {
      this.checkCorrectionNoticeExists(this.bolDetailsId, selectedShipmentType);
    });
  }

  checkCorrectionNoticeExists(bolDetailsId, selectedShipmentType) {
    console.log('in cn');
    this.billOfLadingService.checkCorrectionNoticeExists(bolDetailsId, selectedShipmentType).subscribe(data => {
      if (AppConstants.isNotNullCondition(data)) {
        this.isCorrectionNotice = true;
      }
      this.loader.hide();
    }, error => {
      this.loader.hide();
      console.log(JSON.parse(JSON.stringify(error.error)));
      this.alertService.error('Error getting correction notice');
    });
  }

  viewDocumentBOLPDF(selectedShipmentType: string, copyType: string) {
    this.tmssloader.show();
    const hhgBillOfLadingDetails = new HhgBillOfLadingDetails();
    hhgBillOfLadingDetails.shipmentTypeFromScreen = selectedShipmentType.split('');
    hhgBillOfLadingDetails.bookShipmentId = this.bookShipmentId;

    this.viewBillOfLadingPDF = false;
    this.billOfLadingService.viewDocumentBOLPDFData(selectedShipmentType, this.shipmentId, copyType)
      .subscribe
      (callResp => {
        this.tmssloader.hide();
        this.saveDownloadResponse(callResp);
        this.alertService.success('PDF generated / downloaded successfully');
      }, (error) => {
        this.tmssloader.hide();
        this.alertService.error('Error Downloading Report');
        console.log('== Error => ', error);
      }, () => {
        this.tmssloader.hide();
      });
  }

  viewCorrecionNoticePDF() {
    this.tmssloader.show();
    let shipmentType = 'HHG';
    if (this.selectedShipmentType === 'FRT') {
      shipmentType = 'FRT';
    }
    this.viewBillOfLadingPDF = false;
    this.billOfLadingService.viewCorrectionNoticePDFData(shipmentType, this.shipmentId)
      .subscribe
      (callResp => {
        this.tmssloader.hide();
        this.saveDownloadResponse(callResp);
        this.alertService.success('Correction notice generated / downloaded successfully');
      }, (error) => {
        this.tmssloader.hide();
        this.alertService.error('Error Downloading Report');
        console.log('== Error => ', error);
      }, () => {
        this.tmssloader.hide();
      });
  }

  saveDownloadResponse(downloadResponse: any) {
    console.log('== callResp => ', downloadResponse);
    const byteData: number[] = downloadResponse.byteData;
    const fileName: string = downloadResponse.fileName;
    const numRows: number = downloadResponse.numberOfExcelRows;
    const bytes = new Uint8Array(byteData);
    console.log('numRows:' + numRows);
    const blob = new Blob([bytes], {type: 'application/pdf'});
    const objectUrl = URL.createObjectURL(blob);
    window.open(objectUrl);
    saveAs(blob, fileName);
  }

  /**
   * @description To go back to online booking page
   */
  backToShipmentsControl() {
    this.router.navigate(['/', 'shipmentcontrolreview'], {
      queryParams:
        {bookshipmentid: this.bookShipmentId}
    });
  }
}
